import { Component, OnInit } from '@angular/core';
import { RadiosDataService } from 'src/app/services/radios-data.service';
import { interval, Subscription } from 'rxjs';
import { radiosUrl } from '../../services/radios-url';
import { MatSlider } from '@angular/material/slider';
import { RadioService } from 'src/app/services/radio.service';
import { Radio } from 'src/app/models/radio';

@Component({
  selector: 'app-radio-new',
  templateUrl: './radio-new.component.html',
  styleUrls: ['./radio-new.component.scss']
})
export class RadioNewComponent implements OnInit {
  value = 100;
  radioFM961 = true;
  radioUniversal = false;
  radioAM247 = false
  texto: string = "Radio Centro FM 96.1 MHz";
  playlistONOFF = false;


  subscription: Subscription;
  source = interval(500);

  paused;
  paused2;
  paused3;

  isPlayingUniversal;
  isPlayingAM;
  isPlayingFM;

  selected = true;

  panelOpenState = false;

  audioRadio: any;
  handleChange: MatSlider;
  radios: Radio[];
  constructor(public radiosDataService: RadiosDataService,
    private radioServ: RadioService
  ) {

    this.radioAM247 = this.radiosDataService.RADIOAM247;
    this.radioFM961 = this.radiosDataService.RADIOFM961;
    this.radioUniversal = this.radiosDataService.RADIOUNIVERSAL;
    this.playlistONOFF = this.radiosDataService.PLAYLISTONOFF;
    this.radioServ.getVisible().then(radios => this.radios = radios);
/*     this.subscription = this.radioServ.getVisible().subscribe(radio => {
      this.radios = radio;
    }) */
  }

  playAudioAux(d, url) {
    this.audioRadio = d.getElementById('audioaux');

    if (this.audioRadio != null && this.audioRadio.canPlayType) {
      this.audioRadio.src = url;
      this.audioRadio.play();
    }
    else {
      console.log("SE PRODUJO UN ERROR")
    }

  }

  sliderOnChange(number: any) {
    let covertToVolume = number * 0.01;
    this.audioRadio.volume = covertToVolume;

  }


  stopAudioAux() {
    this.audioRadio = document.getElementById('audioaux');
    if (this.audioRadio != undefined) {
      this.audioRadio.pause();
      this.audioRadio.src = "";
    }
    else {
      console.log("Error")
    }


  }

  changeColorBackgroundButton(d: any) {
    let btnstop = d.getElementById('btnpause');
    let btnplay = d.getElementById('btnplay');
    btnstop.style.background = 'white';
    btnplay.style.background = "red";

  }


  verifyRadioOption(value: string) {

    switch (value) {
      case 'fm96.1':
        this.radioFM961 = true;
        this.radioUniversal = false;
        this.radioAM247 = false
        this.radiosDataService.RADIOAM247 = false;
        this.radiosDataService.RADIOFM961 = true;
        this.radiosDataService.RADIOUNIVERSAL = false;
        this.radiosDataService.PLAYLISTONOFF = false
        this.texto = "Radio Centro FM 96.1 MHz";
        this.stopAudioAux();

        break;
      case 'universal':
        this.radioUniversal = true;
        this.radioFM961 = false;
        this.radioAM247 = false;

        this.radiosDataService.RADIOAM247 = false;
        this.radiosDataService.RADIOFM961 = false;
        this.radiosDataService.RADIOUNIVERSAL = true;

        this.radiosDataService.PLAYLISTONOFF = false
        this.texto = "Radio Universal 106.9 MHz"
        this.stopAudioAux();
        break;
      case 'am24.7':
        this.radioAM247 = true
        this.radioUniversal = false;
        this.radioFM961 = false;

        this.radiosDataService.RADIOAM247 = true;
        this.radiosDataService.RADIOFM961 = false;
        this.radiosDataService.RADIOUNIVERSAL = false;

        this.radiosDataService.PLAYLISTONOFF = false
        this.texto = "Radio Centro AM 1420 kHz"
        this.stopAudioAux();
        break;

      default:
        break;
    }
  }

  verifyRadioToPlay() {
    if (this.radioAM247) {

      this.radiosDataService.RADIOAM247 = true;
      this.radiosDataService.RADIOFM961 = false;
      this.radiosDataService.RADIOUNIVERSAL = false;

      this.radiosDataService.PLAYLISTONOFF = true;
      this.radiosDataService.playCentroAM();
    }
    else if (this.radioFM961) {
      this.radiosDataService.RADIOAM247 = false;
      this.radiosDataService.RADIOFM961 = true;
      this.radiosDataService.RADIOUNIVERSAL = false;
      this.radiosDataService.PLAYLISTONOFF = true;
      this.radiosDataService.playCentroFM();
    }
    else if (this.radioUniversal) {
      this.radiosDataService.RADIOAM247 = false;
      this.radiosDataService.RADIOFM961 = false;
      this.radiosDataService.RADIOUNIVERSAL = true;

      this.radiosDataService.PLAYLISTONOFF = true;
      this.radiosDataService.playradioUniversal();
    }

  }

  public pause(): void {
    this.radiosDataService.pause();
    this.paused = false;
    this.paused2 = false;
    this.paused3 = false;
    this.radiosDataService.PLAYLISTONOFF = false;

    this.radiosDataService.setRadioUniversal(false);
    this.radiosDataService.setRadioCenAM(false);
    this.radiosDataService.setRadioCenFM(false);
  }

  public play(): void {
    this.radiosDataService.playradioUniversal();

    this.paused = true;
    this.paused2 = false;
    this.paused3 = false;

    this.radiosDataService.setRadioUniversal(true);
    this.radiosDataService.setRadioCenAM(false);
    this.radiosDataService.setRadioCenFM(false);

    this.selected = this.isPlayingUniversal;
  }

  public play2(): void {
    this.radiosDataService.playCentroAM();

    this.paused = false;
    this.paused2 = true;
    this.paused3 = false;

    this.radiosDataService.setRadioUniversal(false);
    this.radiosDataService.setRadioCenAM(true);
    this.radiosDataService.setRadioCenFM(false);

    this.selected = this.isPlayingAM;
  }

  public play3(): void {
    this.radiosDataService.playCentroFM();

    this.paused = false;
    this.paused2 = false;
    this.paused3 = true;

    this.radiosDataService.setRadioUniversal(false);
    this.radiosDataService.setRadioCenAM(false);
    this.radiosDataService.setRadioCenFM(true);

    this.selected = this.isPlayingFM;
  }

  public revisarPlay(): void {
    this.isPlayingAM = this.radiosDataService.isPlayingAM();
    this.isPlayingFM = this.radiosDataService.isPlayingFM();
    this.isPlayingUniversal = this.radiosDataService.isPlayingUniversal();

    if (this.paused) {
      this.selected = this.isPlayingUniversal;
    } else if (this.paused3) {
      this.selected = this.isPlayingAM;
    } else if (this.paused2) {
      this.selected = this.isPlayingFM;
    }
  }

  ngOnInit(): void {
    this.paused3 = this.radiosDataService.getRadioCenFM();
    this.paused2 = this.radiosDataService.getRadioCenAM();
    this.paused = this.radiosDataService.getRadioUniversal();

  }

  ngAfterContentInit() {

  }
  ngOnDestroy() {
  }

}
